import { getJson, postJson, putJson, deleteJson, withDone, withOptional, withValidate } from '@rad/utility/http';
export const getPartners = getJson('/api/partners');
export const getSystemPartners = getJson('/api/system/partners');
export const addPartner = (communityId) => withDone(withValidate(postJson('/api/system/partners', { communityId })))();
export const removePartner = (id) => withDone(withOptional(deleteJson(`/api/system/partners/${id}`)))();
export const reorderPartners = (partnerIds) => withDone(withValidate(putJson('/api/system/partners/order', { partnerIds })))();
